import { t } from 'javascripts/utils/withTranslation';
import h from 'hyperscript';

export const accessibilityText = {
  external: t('Extern:'),
  download: t('Download:'),
  mail: t('E-Mail:'),
  phone: t('Telefon:'),
  fax: t('Fax:'),
};

export const linkModifier = [
  'external',
  'download',
  'mail',
  'mail-block',
  'external-block',
  'external-link-new-window',
  'download-block',
  'phone-block',
  'phone',
  'mail-block',
  'fax',
  'fax-block',
];

export default function addAccessibilityTextToLinkType($el, config) {
  const options = { type: 'external', ...config };

  const getElement = (className, fallback) =>
    className ? $el.querySelector(`.${className}`) : fallback;

  const $link = getElement(options.linkClassName, $el);
  const $text = getElement(options.linkTextClassName, $el);
  let originalText = $text?.textContent || '';
  if ($text) {
    const $clone = $text.cloneNode(true);
    // Remove accessibility texts as we add new ones here
    $clone
      .querySelectorAll('.u-hidden-visually')
      .forEach((span) => span.remove());
    originalText = $clone.textContent;
  }
  const addAccessabilityText = accessibilityText[options.type];
  const addTargetText =
    $text && $link.getAttribute('target') === '_blank'
      ? ` (${t('Öffnet in neuem Fenster')})`
      : '';

  if ($text) {
    $text.textContent = '';
    const $span = addAccessabilityText
      ? h('span.u-hidden-visually', `${addAccessabilityText} `)
      : null;
    const $targetSpan = addTargetText
      ? h('span.u-hidden-visually', addTargetText)
      : null;

    if ($span) $text.appendChild($span);
    $text.appendChild(document.createTextNode(`${originalText}`));
    if ($targetSpan) $text.appendChild($targetSpan);
  }
}

// simple RTE Link

const query = `.link, ${linkModifier
  .map((modifier) => `.link-${modifier}, .link--${modifier}, .${modifier}`)
  .join(', ')}`;

document.querySelectorAll(query)?.forEach(($el) => {
  const classList = Array.from($el.classList);
  const matchedType = Object.keys(accessibilityText).find((key) =>
    classList.some((className) => className.includes(key))
  );

  if (matchedType) {
    addAccessibilityTextToLinkType($el, { type: matchedType });
  }
});

// Icon Link

export const iconKeyMatcher = {
  external: ['external', 'bw-arrow-up-right-line'],
  download: ['download', 'bw-arrow-box-down-line'],
  mail: ['email', 'bw-email-line'],
  phone: ['telephone', 'bw-call-line'],
  fax: ['fax', 'bw-invite-line'],
};

export const getMatchFromIconClassList = (iconClassList) =>
  Object.keys(iconKeyMatcher).find((key) =>
    iconKeyMatcher[key].some((iconIdentifier) =>
      Array.from(iconClassList).some((className) =>
        className.includes(iconIdentifier)
      )
    )
  );

export const getMatchFromDomIcon = ($el) => {
  const $icon = $el.querySelector('.icon');
  if (!$icon) return null;

  return getMatchFromIconClassList($icon.classList);
};

document.querySelectorAll('.icon-link')?.forEach(($el) => {
  const matchedType = getMatchFromDomIcon($el);
  if (matchedType) {
    addAccessibilityTextToLinkType($el, {
      type: matchedType,
      linkTextClassName: 'icon-link__text',
    });
  }
});

document.querySelectorAll('.link-list__link')?.forEach(($el) => {
  const matchedType = getMatchFromDomIcon($el);
  if (matchedType) {
    addAccessibilityTextToLinkType($el, {
      type: matchedType,
      linkTextClassName: 'link-list__text',
    });
  }
});
